import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";

import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-react-ui-kit";

import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";

function Locationtopview(props) {
  const [acdActive, setAcdActive] = useState("acdqueues");
  const [fillActive, setFillActive] = useState("tab1");

  const handleFillClick = (value) => {
    if (value === fillActive) {
      return;
    }

    setFillActive(value);
  };
  const handleAcdClick = (value) => {
    if (value === acdActive) {
      return;
    }

    setAcdActive(value);
  };

  const [agent, setAgent] = useState("tab1");

  const advancedData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Address", field: "position", sort: true },
      { label: "911 Verified", field: "office", sort: true },
      { label: "Primary Contact", field: "contact", sort: true },
      { label: "Primary Number", field: "number", sort: true },
      { label: "Users", field: "user", sort: true },
      { label: "IP Phones and Devices", field: "salary", sort: true },
      { label: "Remove", field: "Delete", sort: false },
    ],
    rows: [
      {
        name: "Florida",
        position: "1185 Doss Ave, Orlando, FL32809",
        office: <MDBIcon fas icon="check" className="ms-4 primary checked-icon" />,
        contact: "Nick Leyendecker",
        number: "408 652 3775",
        user: "6",
        salary: "8",
        Remove: <i className="fas fa-xmark text-primary"></i>,
      },
      {
        name: (
          <div>
            San Jose
            <span className="table-default-btn rounded-pill ms-2">Default</span>
          </div>
        ),
        position: "1737N.1st St, Suite 230, San Jose, CA 95122",
        office: <MDBIcon fas icon="check" className="ms-4 primary checked-icon" />,
        contact: "",
        number: "",
        user: "3",
        salary: "4",
        Remove: <i className="fas fa-xmark text-primary"></i>,
      },
      {
        name: "San Jose",
        position: "1737N.1st St, Suite 230, San Jose, CA 95122",
        office: <h6 className="no-red fw-bold">No</h6>,
        contact: "Micher Paxton",
        number: " ",
        user: "7 ",
        salary: "6",
        Remove: <i className="fas fa-xmark text-primary"></i>,
      },
      // Add more rows here if needed
    ],
  };
  const handleAgentClick = (value) => {
    if (value === agent) {
      return;
    }

    setAgent(value);
  };

  const actionData = {
    columns: [
      { label: "Name", field: "name" },
      { label: "Extension", field: "position" },
      {
        label: "Agent Status - Login or Logout of All Assigned Queues",
        field: "checkbox", sort: false
      },
      { label: "Login to Persistent Queues", field: "contact", sort: false },
      { label: "Remove", field: "office", sort: false },
    ],
    rows: [
      {
        name: "All Agents in the List",
        position: "",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
        style: { borderBottom: "2px solid #8bc500 !important" },
      },
      {
        name: "Nick Leyendecker",
        position: "3755",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
      },
      {
        name: "Tatyana Fitzpatrick",
        position: "Regional Director",
        checkbox: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
      },
    ],
  };

  const actionData2 = {
    columns: [
      { label: "Name", field: "name", className: "first-column" },
      { label: "Extension", field: "position" },
      // {
      //     label: "Agent Status - Login or Logout of All Assigned Queues",
      //     field: "checkbox",
      //     sort: false,
      // },
      { label: "Login of Logout All Agents", field: "contact", sort: false },
      { label: "Remove", field: "office" },
    ],
    rows: [
      {
        name: "All Agents in the List",
        position: "",
        // checkbox: (
        // <label className="switch">
        //     <input className="form-control" type="checkbox" />
        //     <span className="slider round"></span>
        // </label>
        // ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
        style: { borderBottom: "2px solid #8bc500 !important" },
      },
      {
        name: "Nick Leyendecker",
        position: "3755",
        // checkbox: (
        // <label className="switch">
        //     <input className="form-control" type="checkbox" />
        //     <span className="slider round"></span>
        // </label>
        // ),
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
      },
      {
        name: "Tatyana Fitzpatrick",
        position: "Regional Director",
        contact: (
          <label className="switch">
            <input className="form-control" type="checkbox" />
            <span className="slider round"></span>
          </label>
        ),
        office: <i className="fas fa-xmark text-primary"></i>,
      },
    ],
  };

  const basicData = {
    columns: ["Name", "Extension", "Set Schedule"],
    rows: [
      [
        "Nick Leyendecker",
        "3755",
        "Monday(9:00 to 6:00 PM), Tuesday (9:00 AM to 6:00 PM), Wednesday(9:00 AM to 6:00 PM) Thrusday(9:00 AM to 6:00 PM), Friday(9:00 AM to 6:00 PM)	",
      ],
    ],
  };

  const addLocation = {
    columns: [
      "Name",
      "Address",
      "Primary Contact",
      "Primary Number",
      "IP Phones and Devices",
      "Remove",
    ],
    rows: [
      [
        "Niks`s House",
        "5487 YourMom Avenue, Pismo Beach, CA 93303",
        "Nick Leyendecker",
        "408 652 3775",
        "2",
        <i className="fas fa-xmark text-primary text-end" alt="Profile" ></i>,
      ],
      [
        "Jeromes Place",
        "2252 Havland Drive, Grants Pass, DR 97527",
        "Jeromes Friesenhahin",
        "408 702 2241",
        "1",
        <i className="fas fa-xmark text-primary text-end" alt="Profile" ></i>,
      ],
    ],
  };

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [AddACDQueue, setAddACDQueue] = useState(false);
  const toggleShow9 = () => setAddACDQueue(!AddACDQueue);

  const [Add911Location, setAdd911Location] = useState(false);
  const toggleShow25 = () => setAdd911Location(!Add911Location);

  return (
    <React.Fragment>
      <>
        <MainLinks active={7} />
        <Body
          tablinks={7}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      <strong>Location</strong>
                    </h5>
                  </div>
                  <div className="card-body px-0">
                    <MDBTabs className="mb-3 mt-2">
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("acdqueues")}
                          active={acdActive === "acdqueues"}
                        >
                          {t("Location")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleAcdClick("generalsettings")}
                          active={acdActive === "generalsettings"}
                        >
                          {t("911 Only Location")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={acdActive === "acdqueues"}>
                        {/* ACD Queues content */}
                        <div className="mx-3">
                          <div className="input-group rounded w-50 d-inline-block">
                            <div className="d-flex w-100 align-items-center">
                              <div className="form-outline w-40">
                                <MDBInput
                                  type="text"
                                  id="datatable-search-input"
                                  label={t("search")}
                                />
                              </div>
                              <div>
                                <MDBBtn
                                  className="green-button d-inline-block float-end ms-3"
                                  data-mdb-toggle="modal"
                                  data-mdb-target="#exampleModal"
                                >
                                  <MDBIcon fas icon="plus" size="sm" /> {t("Add Filter")}
                                </MDBBtn>
                              </div>
                            </div>
                          </div>
                          <MDBBtn className="float-end" onClick={toggleShow9}>
                            <MDBIcon fas icon="plus" size="sm" /> {t("add_ACDQueue")}
                          </MDBBtn>
                        </div>
                        <div>
                          <MDBDatatable data={advancedData} sortField="Name" />
                        </div>
                      </MDBTabsPane>
                      <MDBTabsPane open={acdActive === "generalsettings"}>
                        <div>
                          <div className="mx-3">
                            <div className="input-group rounded w-25 d-inline-block">
                              <MDBInput label="Search" id="form1" type="text" />
                            </div>
                            <MDBBtn
                              className="float-end"
                              onClick={toggleShow25}
                            >
                              {t("Add911Loc")}
                            </MDBBtn>
                          </div>
                        </div>
                        <div className="">
                          <MDBDatatable data={addLocation} sortField="Name" />
                        </div>
                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>

              <MDBModal
                open={AddACDQueue}
                setShow={setAddACDQueue}
                tabIndex="-1"
              >
                <MDBModalDialog centered scrollable size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
                      <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleShow9}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div>
                        <div className="tel-numbers">
                          <strong>{t("ACDQueueName")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control"
                            value="SupportACD"
                          />
                        </div>
                        <div className="tel-numbers mt-2">
                          <strong>{t("extension")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control"
                            value="5805"
                          />
                        </div>
                      </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={toggleShow9}>
                        {t("close")}
                      </MDBBtn>
                      <MDBBtn>{t("add")}</MDBBtn>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>

              <MDBModal
                open={Add911Location}
                setShow={setAdd911Location}
                tabIndex="-1"
              >
                <MDBModalDialog centered scrollable size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>{t("Add911Loc")}</MDBModalTitle>
                      <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleShow25}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div>
                        <div className="tel-numbers">
                          <strong>{t("name")}</strong>
                        </div>
                        <div className="form ">
                          <input
                            type="text"
                            className="w-60"
                            value="jerome's Place"
                          />
                        </div>
                        <div className="tel-numbers mt-1">
                          <strong>{t("StreetAddress")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            value="Prestige Worldwide"
                          />
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            placeholder="Suite, unit, building..."
                          />
                        </div>
                        <div className="tel-numbers mt-1">
                          <strong>{t("City")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            value="Grants Pass"
                          />
                        </div>

                        <div className="row pt-3">
                          <div className="col-6">
                            <div className="tel-numbers">
                              <strong>{t("State")}</strong>
                            </div>
                            <div className="form">
                              <input
                                type="text"
                                value="Oregon"
                                className="w-100"
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="tel-numbers">
                              <strong>{t("ZIPCode")}</strong>
                            </div>
                            <div className="form">
                              <input
                                type="text"
                                value="95727"
                                className="w-100"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="tel-numbers mt-2">
                          <strong>{t("Speclocation")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            value="Grants Pass"
                          />
                        </div>

                        <div className="tel-numbers mt-2">
                          <strong>{t("PrimaryContact")}</strong>
                        </div>
                        <div className="row pt-2">
                          <div className="col-6">
                            <div className="tel-numbers fw-500">{t("firstName")}</div>
                            <div className="form">
                              <input
                                type="text"
                                value="Jerome"
                                className="w-100"
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="tel-numbers fw-500">{t("lastName")}</div>
                            <div className="form">
                              <input
                                type="text"
                                value="Friesenhahn"
                                className="w-100"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="tel-numbers mt-1">
                          <strong>{t("email")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            value="Jerome@panterranetworks.com "
                          />
                        </div>
                        <div className="tel-numbers mt-1">
                          <strong>{t("Number")}</strong>
                        </div>
                        <div className="form pt-1">
                          <input
                            type="text"
                            className="form-control w-100"
                            value="541 856 9547"
                          />
                        </div>
                        <div className="routing-border my-2"> </div>
                        <div className="tel-numbers mt-1">
                          <strong>{t("dedicate911no")}</strong>
                        </div>
                        <select
                          className="form-select form-control w-100"
                          name="San Jose"
                        >
                          <option value="San Jose">
                            --Select a Dedicated number for 911--
                          </option>
                          <option value="San Jose">San Jose</option>
                          <option value="San Jose">San Jose</option>
                          <option value="San Jose">San Jose</option>
                        </select>
                        <div className="tel-numbers mt-1">
                          <strong>{t("billingGroup")}</strong>
                        </div>
                        <select
                          className="form-select form-control w-100"
                          name="San Jose"
                        >
                          <option value="San Jose">San Jose</option>
                          <option value="San Jose">San Jose</option>
                          <option value="San Jose">San Jose</option>
                          <option value="San Jose">San Jose</option>
                        </select>
                      </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={toggleShow25}>
                        {t("close")}
                      </MDBBtn>
                      <MDBBtn>{t("add")}</MDBBtn>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
          }
        />
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default Locationtopview;
